export const getShowPromoCodesInput = ({
  promoCodeSuccess,
  totalOrderNetPrice,
}: {
  promoCodeSuccess: string | undefined;
  totalOrderNetPrice: number | undefined;
}): boolean =>
  Boolean((totalOrderNetPrice && totalOrderNetPrice > 0) || promoCodeSuccess);
